import {
  Outlet,
  createRootRouteWithContext,
  redirect,
} from "@tanstack/react-router"
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"

import { Toaster } from "@/components/ui/sonner"
import type { Permission } from "@/lib/account/permission"
import type { store } from "@/lib/store"
import { isEmbed } from "@/lib/utils"

import type { QueryClient } from "@tanstack/react-query"

interface BoundlessRouterContext {
  hasPermissions: (perm: ReadonlyArray<Permission>) => boolean
  queryClient: QueryClient
  store: typeof store
}

export const Route = createRootRouteWithContext<BoundlessRouterContext>()({
  beforeLoad: ({ context: { store }, location }) => {
    if (!isEmbed()) {
      return
    }

    const isAuthenticated = store.getState().isAuthenticated
    const isEmbedPath =
      location.pathname === "/embed" || location.pathname.startsWith("/embed/")

    if (!isAuthenticated && !isEmbedPath) {
      throw redirect({ to: "/embed" })
    }
  },
  component: () => (
    <>
      <Outlet />
      <Toaster richColors />
      {isEmbed() ? null : (
        <TanStackRouterDevtools
          toggleButtonProps={{ className: "dashboard-router-devtools-toggle" }}
        />
      )}
    </>
  ),
})
